export default function OfferBar() {
    const offers = [
        "🔥 20% OFF on Dubai Luxury Hotels",
        "🏝️ Beach Resorts Starting from AED 199",
        "✈️ Free Breakfast on Selected Stays",
        "💎 Weekend Flash Deals - Limited Time",
        "🏨 Book Early & Save Extra 15%",
    ];

    return (
        <div className="bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-700 text-white py-2 overflow-hidden">
            <div className="whitespace-nowrap animate-scroll flex gap-10 px-4">
                {offers.concat(offers).map((offer, index) => (
                    <span key={index} className="font-medium">
                        {offer}
                    </span>
                ))}
            </div>
        </div>
    );
}